/**
 * notify.ts — Unified Ultra-Premium FinTech Notification & Alert System
 * Wraps react-hot-toast with obsidian glassmorphic styles, specular glow beams,
 * and distinct institutional colorways for Success, Error, Warning, Alert, Info, and Loading.
 */
import toast, { ToastOptions } from 'react-hot-toast';

export const notify = {
  /** Luminous Emerald Success Toast */
  success: (msg: string, opts?: ToastOptions): string => {
    return toast.success(msg, {
      className: 'premium-bybit-toast premium-bybit-toast-success',
      ...opts,
    });
  },

  /** Luminous Crimson Error / Danger Toast */
  error: (msg: string, opts?: ToastOptions): string => {
    return toast.error(msg, {
      className: 'premium-bybit-toast premium-bybit-toast-error',
      ...opts,
    });
  },

  /** Luminous Amber Warning Toast */
  warning: (msg: string, opts?: ToastOptions): string => {
    return toast(msg, {
      className: 'premium-bybit-toast premium-bybit-toast-warning',
      duration: opts?.duration ?? 4500,
      ...opts,
    });
  },

  /** Luminous Amber Alert Toast */
  alert: (msg: string, opts?: ToastOptions): string => {
    return toast(msg, {
      className: 'premium-bybit-toast premium-bybit-toast-warning',
      duration: opts?.duration ?? 4500,
      ...opts,
    });
  },

  /** Luminous Cyan / Electric Blue Info Toast */
  info: (msg: string, opts?: ToastOptions): string => {
    return toast(msg, {
      className: 'premium-bybit-toast premium-bybit-toast-info',
      duration: opts?.duration ?? 4000,
      ...opts,
    });
  },

  /** Luminous Gold Pulsing Loading Toast */
  loading: (msg: string, opts?: ToastOptions): string => {
    return toast.loading(msg, {
      className: 'premium-bybit-toast premium-bybit-toast-loading',
      ...opts,
    });
  },

  /** Dismiss specific or all active toast notifications */
  dismiss: (id?: string): void => {
    toast.dismiss(id);
  },
};

// Expose on window for runtime testing / dev diagnostics
if (typeof window !== 'undefined') {
  (window as unknown as { notify: typeof notify }).notify = notify;
}

export default notify;
